export default __webpack_public_path__ + "static/media/food01.f9a64538.png";